(function () {
    "use strict";

    angular.module("app").directive("infinitescroll", InfiniteScrollDirectiveFactory);

    function InfiniteScrollDirectiveFactory() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('scroll', function () {
                    const scrollTop = element[0].scrollTop;
                    const offsetHeight = element[0].offsetHeight;
                    const scrollHeight = element[0].scrollHeight;
                    const scrolledTo = scrollTop + offsetHeight;
                    if (scrolledTo < (scrollHeight - 300))
                        return;
                    scope.$apply(attrs.infinitescroll);
                });
            }
        };
    }
})();
